"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncientDecayTickEffectHandler = exports.AncientDecayTickEffectArgs = void 0;
const Damage_1 = require("../../Damage");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Damage_2 = require("./Damage");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
class AncientDecayTickEffectArgs {
    constructor(amount) {
        this.amount = amount;
        this.__type = EffectType_1.EffectType.AncientDecayTick;
        this.__typeName = "AncientDecayTick";
        this.name = "Ancient Decay";
        this.harmful = true;
    }
}
exports.AncientDecayTickEffectArgs = AncientDecayTickEffectArgs;
let AncientDecayTickEffectHandler = class AncientDecayTickEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            duration: Duration_1.Duration.Permanent,
            effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Health, state.args.amount),
            supernatural: true
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
        container.applyEffect(sequence, state.creatorId, state.targetId, new Damage_2.DamageEffectArgs(new Damage_1.Damage(enums_1.DamageType.Death, Math.round(state.args.amount * .5)), false, true), Duration_1.Duration.Instant, true);
    }
};
AncientDecayTickEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.AncientDecayTick)
], AncientDecayTickEffectHandler);
exports.AncientDecayTickEffectHandler = AncientDecayTickEffectHandler;
